import { getUser } from 'helpers/auth';

import {
  CompanyCreationDocumentType,
  ShineStartDocumentType,
} from '../../../../../__generated__/GQL';
import documentTypeProperties from './documentTypeProperties';
import { UploadableDocumentType } from './types';

// TODO(matt): Don't add a default env but instead update the typing of
// the shine-start-library to allow the API_ENV property to be undefined.
const DEFAULT_API_ENV = 'production';

const getDownloadFormUrl = (document: {
  type: ShineStartDocumentType | CompanyCreationDocumentType;
}): string | undefined => {
  if (document.type === null || !(document.type in documentTypeProperties)) {
    return undefined;
  }
  const { downloadFormUrl } =
    documentTypeProperties[document.type as UploadableDocumentType];
  if (typeof downloadFormUrl === 'function') {
    const user = getUser();
    if (user === null) {
      throw new Error('Missing user data');
    }
    const { uid } = user;
    return downloadFormUrl({
      API_ENV: import.meta.env.API_ENV || DEFAULT_API_ENV,
      uid,
    });
  }
  return downloadFormUrl;
};

export default getDownloadFormUrl;
